module.exports = __webpack_public_path__ + "static/media/no-jobers.7cbbd203.svg";